import {getWords,getNewWords,wordLogin,wordLoginOut,clockWords,getReviewWords,planWord,allPlanWord,recoverWord,getDateWords} from "../../../components/network/recitewords";
import Vue from "vue";

export default {

    requireWord(context,payload){
        getWords(payload).then(res => {
            const words={word:payload,resDate:res}
            context.commit('getWord',words);
            // console.log(res)

        })
    },
    requireNewWord(context){
        getNewWords(context.state.newWordListNum).then(res=>{
            // console.log(res);
            context.commit('getNewWord',res);
        });
    },
    requireDateWord(context,payload){
        getDateWords(payload).then(res=>{
            // console.log(res);
            context.commit('getNewWord',res);
        });
    },

    requireReviewWord(context){
        return new Promise((resolve )=> {
            getReviewWords(context.state.newWordListNum).then(res=>{


                if(res.data.length==0){
                    resolve("今天没有单词需要复习!你可以学习新的单词");
                }else{
                    context.commit('getNewWord',res);
                }
            });
        })

    },
    requireRecoverWord(context){
        return new Promise((resolve )=> {
            recoverWord(context.state.newWordListNum).then(res=>{
                // console.log(res.data)

                let aaa='<div>' ;
                for(let i=0;i<res.data.length;i++){
                    aaa = aaa +" 回收"+ res.data[i].startdate+" 号:"+res.data[i].num+ "个"+  '<br>';
                }
                aaa = aaa +'</div>'
                resolve(aaa);
                context.commit('getRecoverWord',res);
            });
        })
    },
    requirePlanWord(context){
        planWord(context.state.newWordListNum).then(res=>{
            // console.log(res);
            context.commit('getPlanWord',res);
        });
    },
    requireAllPlanWord(context){
        allPlanWord().then(res=>{
            // console.log(res);
            context.commit('getAllPlanWord',res);
        });
    },

    requireWordLogin(context,payload){
        return new Promise((resolve,reject )=> {
            // console.log(payload.pass);
            wordLogin(payload.userAccount,payload.pass).then(res=>{
                // console.log(res.data);
                // console.log(res.data.account);
                if(res.data.account==0){
                    // alert("11")
                    reject();
                }else{
                    context.commit('getUsername',res.data);
                    resolve(res.data.account);
                }
                // alert(res.data.account)
                //                 // context.commit('getUsername',res.data);
                //                 // resolve(res.data.account);

            })
        })

    },

    requireWordLoginOut(context,payload){
        return new Promise((resolve,reject )=> {
            // console.log(payload.pass);
            wordLoginOut().then(res=>{
                // console.log(res.data.password);
                // console.log(res.data.account);
                // if(res.data==){
                //
                //     reject();
                // }else{
                //     context.commit('getUsername',res.data);
                //     resolve(res.data.account);
                // }

            })
        })

    },

    checkWord(context,payload){

        return new Promise((resolve,reject )=> {
            if(context.state.wordListSwitch){
                let word=context.state.newWordList[context.state.currentCardItemIndex].word;
                if(payload==context.state.newWordList[context.state.currentCardItemIndex].word){
                    clockWords(context.state.newWordList[context.state.currentCardItemIndex].id).then(res=>{
                        context.commit('changeNewList');

                        setTimeout(()=> {
                            context.commit('setIsBackCardWordItem');
                        },100)

                        resolve(word);
                    })
                }else{
                    context.commit('getInputWord',payload);
                    reject(word);
                }

            }else{
                context.commit('getInputWord',payload);
                reject();
            }
            // alert("01010")
            // let word=context.state.newWordList[context.state.currentCardItemIndex].word;
            // if (context.state.wordListSwitch&&payload==context.state.newWordList[context.state.currentCardItemIndex].word){
            //
            //     clockWords(context.state.newWordList[context.state.currentCardItemIndex].id).then(res=>{
            //         context.commit('changeNewList');
            //
            //         setTimeout(()=> {
            //             context.commit('setIsBackCardWordItem');
            //         },100)
            //
            //         resolve(word);
            //     })
            // }else{
            //     alert("9999")
            //     context.commit('getInputWord',payload);
            //     reject(word);
            // }
            // alert("000")

        // }).then(res=>{
        //     alert("14");
        //     alert(res);
        //     alert(context.state.currentCardItemIndex);
        //     return new Promise(resolve => {
        //         setTimeout(()=>{
        //             // alert(context.state.isBackCardWordItem);
        //             // if(context.state.isBackCardWordItem){
        //                 context.commit('setIsBackCardWordItem');
        //                 // state.backCardWordItemNum=state.currentCardItemIndex;
        //                 resolve(res);
        //
        //                 // reject()
        //             // }else{
        //                 // resolve()
        //
        //             // }
        //         },100)
        //     })
        // }).catch((err)=>{
        //     alert("44444")
        //     return new Promise(reject => {
        //         reject();
        //     })
        //     // reject();
        });
    }

}